// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Actions
import { setFundChartZoom } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/zoom/zoom.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
// Types / enums
import { ChartDateZoom } from 'ChartApp/ts/enums/chart-common.enum';
export const zoom = createReducer(ChartDateZoom.CHART_ZOOM_ONE_YEAR, on(setChartData, (state, { chartData }) => chartData.params.zoom), on(setFundChartZoom, (state, action) => action.zoom));
